export default __webpack_public_path__ + "static/media/D_Dinner.0b227795.svg";